export default "__VITE_ASSET__IFUi8VYp__"